/**
 * Statut d'un UserTest — le seul point réellement partagé entre les trois
 * lectures de `GET /api/user-tests` (SAAS-887).
 *
 * @remarks
 * `tech-tests`, `candidate-results` et `cv` lisent chacun cet endpoint avec
 * leur propre schéma Zod, et c'est volontaire : `tech-tests` a besoin des
 * champs d'évaluation (durée, tags, dépendances), `candidate-results` du détail
 * des tentatives (score, dates), `cv` d'une forme minimale pour un sélecteur.
 * Forcer un schéma de réponse commun aurait produit un module que les trois
 * features tirent dans trois directions — pire que la duplication qu'il visait
 * à corriger.
 *
 * Cette table-ci, en revanche, était recopiée à l'identique dans `tech-tests`
 * (`API_STATUS_MAP`) et `candidate-results` (`TEST_STATUS_MAP`), vers deux
 * unions de types déclarées séparément mais structurellement identiques. C'est
 * le seul vrai doublon des trois lectures — extrait ici plutôt que laissé
 * diverger au prochain statut ajouté côté back.
 */

const STATUS_MAP: Record<string, 'not-started' | 'in-progress' | 'completed' | 'expired'> = {
  pending: 'not-started',
  in_progress: 'in-progress',
  completed: 'completed',
  expired: 'expired',
  abandoned: 'expired',
};

export function mapUserTestStatus(
  raw: string,
): 'not-started' | 'in-progress' | 'completed' | 'expired' {
  return STATUS_MAP[raw.toLowerCase()] ?? 'not-started';
}
